









































































































































































































































































































































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import GsModalDialog from "@/components/modal/GsModalDialog.vue";
import LocalizadorEndereco from "./LocalizadorEndereco.vue";
import ConsultaVeiculo from "./ConsultaVeiculo.vue";
import { assistencia24hModule } from "@/store/assistencia24h/Assistencia24h";
import ServicosAssistenciaService from "@/service/assistencia24h/ServicosAssistenciaService";
import LocalidadeModel from "@/models/geolocalizacao/LocalidadeModel";
import { VeiculoModel } from "@/models/cadastros/assistencia/veiculo/VeiculoModel";
import { TipoServicoEnum } from "@/api/assistencia24h/TipoServicoEnum";
import { MOTIVOS_SERVICO_CHAVEIRO, MotivoServicoModel } from "@/models/cadastros/assistencia/chaveiro/MotivoServicoModel";
import { QuestionarioChaveiroModel } from "@/models/cadastros/assistencia/chaveiro/QuestionarioChaveiroModel";
import { ValidationObserver } from "vee-validate";
import ContatoLocal from "./ContatoLocal.vue";
import { DadosPagamentoServicoModel } from "@/models/cadastros/assistencia/DadosPagamentoServicoModel";
import ServicoSubClienteModel from "@/models/cadastros/assistencia/ServicoSubClienteModel";
import ServicoSubCliente from "./ServicoSubCliente.vue";
import { ArquivoAnexoModel } from "@/models/cadastros/assistencia/guincho/ArquivoAnexoModel";
import ClienteAdministrativo from "./ClienteAdministrativo.vue";
import ClienteAdministrativoModel from "@/models/cadastros/assistencia/ClienteAdministrativoModel";
import { tiposEndereco } from "@/models/cadastros/assistencia/TipoEndereco";
import { estadosList } from "@/models/Estados";
import { moneyMaskProperties } from "@/models/VuetifyMoneyModel";
import ValoresClienteAdministrativoModel from "@/models/cadastros/assistencia/ValoresClienteAdministrativoModel";

@Component({
  components: {
    LocalizadorEndereco,
    ConsultaVeiculo,
    ContatoLocal,
    GsModalDialog,
    ServicoSubCliente,
    ClienteAdministrativo,
  },
  beforeRouteEnter: (to, from, next) => {
    window.scrollTo(0, 0);
    next((vm: any) => {
      const vueComponent = vm as QuestionarioChaveiro;
      if (from.name === "ConfirmacaoDadosPrecificacao") {
        vueComponent.loadFromStore();
      } else {
        vueComponent.resetStore();
      }
      assistencia24hModule.SET_TIPO_SERVICO(TipoServicoEnum.CHAVEIRO);
    });
  },
})
export default class QuestionarioChaveiro extends Vue {
  $refs!: {
    chaveiroObserver: InstanceType<typeof ValidationObserver>;
  };

  veiculoDoAssociado = true;
  nomeContatoNoLocal = "";
  telefoneContatoNoLocal = "";
  veiculo: VeiculoModel = {
    placa: "",
    chassi: "",
    marca: "",
    modelo: "",
    anoFabricacao: "",
    anoModelo: "",
    cor: "",
    combustivel: "",
    cilindrada: "",
    tipoVeiculo: { valor: "", texto: "" },
  };
  enderecoSelecionado: LocalidadeModel = new LocalidadeModel();
  motivosSolicitacao = MOTIVOS_SERVICO_CHAVEIRO;
  motivoSolicitacao?: MotivoServicoModel = {
    codigo: -1,
    valorIntegracao: "",
    descricao: "",
  };

  showDialog = false;
  dialogMessage = "";

  dialogType = "";
  showDialogFrota = false;
  dialogTitle = "";
  dialogMessageAux = "";
  successDialog = false;
  loadingFrota  = false;

  cardForm: DadosPagamentoServicoModel = {
    id: 0,
    bandeira: undefined,
    codigoSeguranca: undefined,
    nomeTitular: undefined,
    numeroCartao: undefined,
    validade: undefined
  };

  isFrota = false;
  enderecoServicoFrota: LocalidadeModel = new LocalidadeModel();
  servicoSubClienteFrota: ServicoSubClienteModel = new ServicoSubClienteModel();
  arquivoAtual?: File[];
  tiposPermitidos: string[]= ['jpg','png','gif','png','bmp'];
  fotosAcidente: ArquivoAnexoModel[] = [];
  exibirCampoFotos = false;

  tiposEnderecos = tiposEndereco;
  estados = estadosList;
  enderecoClienteAdministrativo: LocalidadeModel = new LocalidadeModel();
  clienteAdm = false;
  clienteAdministrativo: ClienteAdministrativoModel = new ClienteAdministrativoModel();
  showDialogAdm = false;
  moneyMaskProperties = moneyMaskProperties;
  valoresAdm: ValoresClienteAdministrativoModel = new ValoresClienteAdministrativoModel();
  valoresPrecificado: ValoresClienteAdministrativoModel = new ValoresClienteAdministrativoModel();
  precoLabel = "Vl. Total";
  loading = false;

  async atualizaValores() {
    let preco = 0;
    if (!this.valoresAdm.checkboxValorSaida) {
      preco -= this.valoresAdm?.valorSaida || 0;
    } 

    if ((this.valoresAdm?.valorHoraParada || 0) > 0) {
      if ((this.valoresAdm?.qtdHoraParada || 0) == 0) {
        this.valoresAdm.qtdHoraParada = 1;
      }
    }

    if ((this.valoresAdm?.valorHoraTrabalhada || 0) > 0) {
      if ((this.valoresAdm?.qtdHoraTrabalhada || 0) == 0) {
        this.valoresAdm.qtdHoraTrabalhada = 1;
      }
    }

    if ((this.valoresAdm?.valorPatins || 0) > 0) {
      if ((this.valoresAdm?.qtdPatins || 0) == 0) {
        this.valoresAdm.qtdPatins = 1;
      }
    }
    await assistencia24hModule
        .recalcularValorServico({
          idServico: assistencia24hModule.precificacao?.idServico || 1,
          idCliente: this.valoresAdm.idCliente || 0,
          idPagamentoCliente: 0,
          numeroParcelas: 0,
          pagamentoCliente: this.cardForm,
          valoresAdministrativo: this.valoresAdm,
          valoresPrecificado: this.valoresPrecificado
        })
        .then((res: any) => {
          preco = res;
        })
        .catch((err: any) => {
          console.error(err);
          this.closeDialog();
          this.openDialog(
            "error", 
            "Erro ao recalcular serviço", 
            "Tivemos problemas recalcular o valor do serviço. Tente novamente."
            );
        });

        this.valoresAdm.preco = preco
        this.dialogTitle = "Valor da Solicitação " + this.valoresAdm.preco.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'});
  }

  
  @Watch("clienteAdministrativo")
  obterDadosClienteAdm(val: any) {
    this.isFrota = false;
    this.clienteAdm = false;
    this.enderecoClienteAdministrativo = new LocalidadeModel();
    if (val.frota) {
      this.isFrota = true;
    }

    if (val.id) {
      this.clienteAdm = true;
    }

    if (val.endereco) {
      this.enderecoClienteAdministrativo = val.endereco;
      this.enderecoClienteAdministrativo.tipoEndereco = this.tiposEnderecos.find(endereco => endereco.valor === val.endereco.tipo);
      this.enderecoClienteAdministrativo.estado = this.estados.find(estado => estado.sigla === val.endereco.estado);
    }
    
  }

  exibirFotos() {
    this.exibirCampoFotos = false;
    if (this.motivoSolicitacao?.codigo == 1 || this.motivoSolicitacao?.codigo == 2 || this.motivoSolicitacao?.codigo == 4) {
      this.exibirCampoFotos = true;
    }
  }

  validarExtensao(extensaoArquivo:string) {
    const tipoFotoFiltro = this.tiposPermitidos.find(tipo => tipo == extensaoArquivo.toLowerCase());
    if(!tipoFotoFiltro) {
      return false;
    }
      return true;
  }

  handleFileUpload() {
    if (this.arquivoAtual) {
      this.arquivoAtual.forEach((foto) => {
        if(!this.validarExtensao(foto.name.split('.')[1])) {
          this.openDialog("error", "Extensão inválida", "Extensão de arquivo inválida usar jpg, gif, png, bmp.");
          this.arquivoAtual = []
          return
        }

        ServicosAssistenciaService
          .uploadFotos(foto)
          .then((res) => {
            this.fotosAcidente.push({
              arquivo: foto,
              UID: res.nomeArquivo,
            });
            this.arquivoAtual = undefined;
          })
          .catch((err) => {
            this.$refs.chaveiroObserver.setErrors({
              upload: "Ocorreu um erro ao efetuar o upload da foto",
            });
          });
      });
    }
  }

  removerArquivo(arquivo: ArquivoAnexoModel) {
    this.fotosAcidente.splice(
      this.fotosAcidente.indexOf(arquivo),
      1
    );
  }

  confirmar() {
    if (this.valoresAdm.frota) {
      this.confirmarFrota();
    } else {
      this.confirmarAdm();
    }
  }

  confirmarAdm() { 
    this.loadingFrota = true;
    assistencia24hModule
        .confirmarSolicitacaoAdm({
          idServico: assistencia24hModule.precificacao?.idServico || 1,
          idCliente: this.valoresAdm.idCliente || 0,
          idPagamentoCliente: 0,
          numeroParcelas: 0,
          pagamentoCliente: this.cardForm,
          valoresAdministrativo: this.valoresAdm,
          valoresPrecificado: this.valoresPrecificado
        })
        .then((res: any) => {
          this.closeDialog();
          this.loadingFrota = false;
          this.successDialog = true;
          this.openDialog(
            "success", 
            "Serviço solicitado com sucesso!", 
            "Acompanhe as solicitações através do menu Acompanhar Solicitações."
          );
          this.$router.push({ name: "HomePage" });
        })
        .catch((err: any) => {
          console.error(err);
          this.closeDialog();
          this.loadingFrota = false;
          this.openDialog(
            "error", 
            "Erro ao solicitar serviço", 
            "Tivemos problemas na solicitação do serviço. Tente novamente."
            );
        });
  }

  confirmarFrota() { 
    this.loadingFrota = true;
    assistencia24hModule
        .confirmarSolicitacaoFrota({
          idServico: assistencia24hModule.precificacao?.idServico || 1,
          idCliente: this.clienteAdministrativo.id || 0,
          idPagamentoCliente: 0,
          numeroParcelas: 0,
          pagamentoCliente: this.cardForm,
          valoresAdministrativo: this.valoresAdm,
          valoresPrecificado: this.valoresPrecificado
        })
        .then((res: any) => {
          this.closeDialog();
          this.loadingFrota = false;
          this.successDialog = true;
          this.openDialog(
            "success", 
            "Serviço solicitado com sucesso!", 
            "Acompanhe as solicitações através do menu Acompanhar Solicitações."
          );
          this.$router.push({ name: "HomePage" });
        })
        .catch((err: any) => {
          console.error(err);
          this.closeDialog();
          this.loadingFrota = false;
          this.openDialog(
            "error", 
            "Erro ao solicitar serviço", 
            "Tivemos problemas na solicitação do serviço. Tente novamente."
            );
        });
  }
  
  mounted() {
    window.scrollTo(0, 0);
    this.openDialog(
        "information", 
        "Chaveiro", 
        "O serviço é somente para abertura do veículo e retirada da chave de miolo, não será fornecida outra chave."
      );
  }

  async resetStore() {
    await assistencia24hModule.RESET();
  }

  loadFromStore() {
    const questionarioChaveiro = assistencia24hModule.questionarioChaveiro;
    this.veiculoDoAssociado = questionarioChaveiro?.veiculoPertenceAoAssociado || true;
    this.veiculo = questionarioChaveiro?.veiculo || {
      placa: "",
      chassi: "",
      marca: "",
      modelo: "",
      anoFabricacao: "",
      anoModelo: "",
      cor: "",
      combustivel: "",
      cilindrada: "",
      tipoVeiculo: { valor: "", texto: "" },
    };
    this.enderecoSelecionado = questionarioChaveiro?.localizacao || new LocalidadeModel();
    this.nomeContatoNoLocal = questionarioChaveiro?.nomeContatoNoLocal || "";
    this.telefoneContatoNoLocal = questionarioChaveiro?.telefoneContatoNoLocal || "";
    this.motivoSolicitacao = questionarioChaveiro?.motivoSolicitacao || {
      codigo: -1,
      valorIntegracao: "",
      descricao: "",
    };
    this.servicoSubClienteFrota =
    questionarioChaveiro?.servicoSubCliente || new ServicoSubClienteModel();
      this.enderecoServicoFrota.cep = questionarioChaveiro?.servicoSubCliente?.cep || "";
      this.clienteAdministrativo =
    questionarioChaveiro?.clienteAdministrativo || new ClienteAdministrativoModel();
      this.clienteAdministrativo.endereco!.cep = questionarioChaveiro?.clienteAdministrativo?.endereco?.cep || "";  
  }

  solicitarPrecificacao() {

    this.$refs.chaveiroObserver.validate().then((valid: boolean) => {

    if (!valid) {
      this.openDialog(
        "information", 
        "Dados incompletos", 
        "Preencha todos os campos obrigatórios para continuar com a solicitação do serviço."
      );
      return;
    }

    if (valid) {
      this.loading = true;  
        if (this.exibirCampoFotos) {
          if (this.fotosAcidente.length == 0) {
            this.openDialog(
              "error", 
              "Fotos", 
              "É necessário o envio das fotos da ocorrência."
            );
            return;
          }
        }
        
        if (this.enderecoServicoFrota) {
          this.servicoSubClienteFrota.cep = this.enderecoServicoFrota.cep;
          this.servicoSubClienteFrota.tipoEndereco = this.enderecoServicoFrota.tipoEndereco; 
          this.servicoSubClienteFrota.logradouro = this.enderecoServicoFrota.logradouro; 
          this.servicoSubClienteFrota.numero = this.enderecoServicoFrota.numero;
          this.servicoSubClienteFrota.complemento = this.enderecoServicoFrota.complemento || ""; 
          this.servicoSubClienteFrota.bairro = this.enderecoServicoFrota.bairro; 
          this.servicoSubClienteFrota.cidade = this.enderecoServicoFrota.cidade; 
          this.servicoSubClienteFrota.estado = this.enderecoServicoFrota.estado; 
        }
        if (this.enderecoClienteAdministrativo) {
          this.clienteAdministrativo.endereco = this.enderecoClienteAdministrativo;
        }
        const questionarioChaveiro = new QuestionarioChaveiroModel(
          this.veiculoDoAssociado,
          this.veiculo,
          this.enderecoSelecionado,
          this.motivoSolicitacao || {
            codigo: -1,
            valorIntegracao: "",
            descricao: "",
          },
          this.nomeContatoNoLocal,
          this.telefoneContatoNoLocal,
          this.servicoSubClienteFrota,
          this.fotosAcidente,
          this.clienteAdministrativo
        );
        assistencia24hModule.SET_QUESTIONARIO_CHAVEIRO(questionarioChaveiro);

        assistencia24hModule
          .solicitarPrecificacaoChaveiro()
          .then((res: any) => {
            if (assistencia24hModule.precificacao) {
              const precificacao = assistencia24hModule.precificacao as Record<string, any>;
              this.valoresAdm = {
                  valorTotalAdicional: precificacao.valorTotalAdicional ?? 0,
                  valorHoraParada: precificacao.valorHoraParada ?? 0,
                  valorPatins: precificacao.valorPatins ?? 0,
                  valorHoraTrabalhada: precificacao.valorHoraTrabalhada ?? 0,
                  valorPedagio: precificacao.valorPedagio ?? 0,
                  valorPrestador: precificacao.valorPrestador ?? 0,
                  valorGuinchoPesado: precificacao.valorGuinchoPesado ?? 0,
                  valorOperadora: precificacao.valorOperadora ?? 0,
                  valorComissaoCorretor: precificacao.valorComissaoCorretor ?? 0,
                  valorAgravo: precificacao.valorAgravo ?? 0,
                  valorDesconto: precificacao.valorDesconto ?? 0,
                  idCliente: precificacao.idCliente,
                  frota: precificacao.frota ?? false,
                  preco: precificacao?.preco ?? 0,
                  valorSaida: precificacao?.valorSaida ?? 0,
                  valorExcedente: precificacao?.valorExcedente ?? 0,
                  qtdKmExcedente: precificacao?.qtdKmExcedente ?? 0,
                  checkboxValorSaida: true,
                  qtdPatins: 0,
                  qtdHoraTrabalhada: 0,
                  qtdHoraParada: 0,
                  kmTotal: precificacao?.kmTotal?? 0
              };

              this.valoresPrecificado = {
                  valorTotalAdicional: precificacao.valorTotalAdicional ?? 0,
                  valorHoraParada: precificacao.valorHoraParada ?? 0,
                  valorPatins: precificacao.valorPatins ?? 0,
                  valorHoraTrabalhada: precificacao.valorHoraTrabalhada ?? 0,
                  valorPedagio: precificacao.valorPedagio ?? 0,
                  valorPrestador: precificacao.valorPrestador ?? 0,
                  valorGuinchoPesado: precificacao.valorGuinchoPesado ?? 0,
                  valorOperadora: precificacao.valorOperadora ?? 0,
                  valorComissaoCorretor: precificacao.valorComissaoCorretor ?? 0,
                  valorAgravo: precificacao.valorAgravo ?? 0,
                  valorDesconto: precificacao.valorDesconto ?? 0,
                  idCliente: precificacao.idCliente,
                  frota: precificacao.frota ?? false,
                  preco: precificacao?.preco ?? 0,
                  valorSaida: precificacao?.valorSaida ?? 0,
                  valorExcedente: precificacao?.valorExcedente ?? 0,
                  qtdKmExcedente: precificacao?.qtdKmExcedente ?? 0,
                  checkboxValorSaida: true,
                  qtdPatins: 0,
                  qtdHoraTrabalhada: 0,
                  qtdHoraParada: 0,
                  kmTotal: precificacao?.kmTotal?? 0
              };
            };
            if (assistencia24hModule.precificacao?.frota && assistencia24hModule.precificacao?.faturamento) {
              this.closeDialog();
              this.openDialogCliente( 
                "confirm",
                "Valor da Solicitação " + assistencia24hModule.precificacao?.preco.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'}) ,
                "O Pagamento acontecerá no fechamento da sua fatura com os descontos negociados.",
                "Acompanhe as solicitações através do menu Acompanhar Solicitações."
              );
            } else {
              this.openDialogCliente( 
                "confirm",
                "Valor da Solicitação " + assistencia24hModule.precificacao?.preco.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'}) ,
                "",
                ""
              );
            }
          })
          .catch((err: any) => {
            this.loading = false;  
            console.error(err);
            this.openDialog(
              "error", 
              "Erro ao solicitar serviço", 
              err.message
            );
          });
        } 
      });
  }

  closeDialog() {
    this.showDialog = false;
    this.dialogMessage = "";
    this.dialogMessageAux = "";
    this.showDialogFrota = false;
    this.showDialogAdm = false;
    this.loading = false;  
    if (this.successDialog) {
      this.$router.push({ name: "MinhasSolicitacoes" });
    }
    this.successDialog = false;
  }

  private openDialogCliente(dialogType: string, title: string, message: string, messageAux: string) {
    this.dialogType = dialogType;
    this.dialogTitle = title;
    this.dialogMessage = message;
    this.dialogMessageAux = messageAux;
    this.showDialogAdm = true;
    this.loading = false;  
  }

  private openDialogFrota(dialogType: string, title: string, message: string, messageAux: string) {
    this.dialogType = dialogType;
    this.dialogTitle = title;
    this.dialogMessage = message;
    this.dialogMessageAux = messageAux;
    this.showDialogFrota = true;
  }

  private openDialog(dialogType: string, title: string, message: string) {
    this.dialogType = dialogType;
    this.dialogTitle = title;
    this.dialogMessage = message;
    this.showDialog = true;
  }

  get btnText() {
    let text: string;
    switch (this.dialogType) {
      case "success":
        text = "Ok, entendi";
        break;
      case "error":
        text = "Fechar";
        break;
      case "confirm":
        text = "Cancelar";
        break;
      case "information":
        text = "Ok, entendi";
        break;
      default:
        text = "Ok, entendi";
        break;
    }
    return text;
  }

  get btnColor() {
    let color: string;
    switch (this.dialogType) {
      case "success":
        color = "#00CD96";
        break;
      case "error":
        color = "error";
        break;
      case "confirm":
        color = "error";
        break;
      case "information":
        color = "primary";
        break;
      default:
        color = "primary";
        break;
    }
    return color;
  }

  get dialogImg() {
    return `${this.dialogType}.png`;
  }
}
